import Vue from 'vue'
import Router from 'vue-router'
import Home from './components/Home.vue'
import Question from './components/testQuestion.vue'
import Score from './components/Score.vue'
import Camera from "./components/Camera";
import NotFound from "./components/404";
import Sjerr from "./components/Sj_err";

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: Home
    },
    {
      path: '/camera',
      component: Camera
    },
    {
      path: '/question/:sj_id?',
      component: Question
    },
    {
      path: '/score/:sj_id',
      component: Score
    },
    {
      path: '/sje',
      component: Sjerr
    },
    { path: '*', component: NotFound },
    {
      path: '/w_index',
      component: () => import('./components/w_index.vue')
    },
    {
      path: '/audio',
      component: () => import('./components/Audio.vue')
    },
    {
      path: '/faceDetect/:sj_id',
      component: () => import('./components/FacePhoto.vue')
    },
    {
      path: '/testFacePhoto/:sj_id',
      component: () => import('./components/testFacePhoto.vue')
    },
    {
      path: '/testScore/:sj_id',
      component: () => import('./components/testScore.vue')
    },
    {
      path: '/video',
      component: () => import('./components/Video.vue')
    }

  ]
})
